module.exports = __webpack_public_path__ + "static/media/boost.d4330994.svg";